import React from "react";
import { connect } from 'react-redux';
import { compose } from 'redux';

import * as actions from '../store/actions/auth';

import { withStyles } from '@material-ui/core/styles';
import {Button, TextField} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import '@fontsource/roboto';


import axios from 'axios';


axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";



const useStyles = theme => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '25ch',
      },
    },
    error:{
        color: 'black'
    },
    form:{
        textAlign: 'center',
        padding: '20px'

    }
  });


class MTurkSignUp extends React.Component {
    constructor(props){
        super(props);
        this.state={
            username: '',
            password: '',
        }
        this.setUsername=this.setUsername.bind(this);
        this.handleSubmit=this.handleSubmit.bind(this);
    }

    setUsername(newusername){
        this.setState(() => ({
            username: newusername,
            password: newusername
        }))
    }
    validateForm(){
      return (this.state.username.length > 3 && this.state.password.length >3)

    }

    handleSubmit(event){
        event.preventDefault();
        this.props.onAuth(
            this.state.username,
            this.state.password,
        );
//        this.props.history.push('/');
        /* $.ajax({
            url: 'http://3.34.193.205:8000/api/signup/',
            type: 'POST',
            data: {
                username: this.state.username
            },
            headers:{
                "X-CSRFToken":cookie.load('csrfToken'),
            },
            withCredentials: true,
            success: function(data){
                console.log('success')
                console.log('before', cookie.load('csrfToken'))
                
                window.alert('clicked')
                console.log(data)
                if(data.isNew){
                    window.alert('signed up')
                    document.cookie = 'csrfToken='+data.csrfToken;
                    console.log('after', cookie.load('csrfToken'))
                    updateUserInfo(true, data.username, data.nickname);
                }
            }
        }) */
  }

    render(){
        const {classes} = this.props;

        return (
            <div style={{padding: '40px', backgroundColor: 'white', paddingBottom: '100px'}}>
              <Typography variant='h5' className={classes.li}>Let's start with your MTurk ID.</Typography> 
                <form className={classes.form} noValidate autoComplete="off" onSubmit={this.handleSubmit}>
                
                <TextField label="ID" variant="outlined" size='small' style={{marginRight: '5px', marginTop:'2px'}} onChange={e => this.setUsername(e.target.value)} />
                <Button variant='contained' size='large' color='primary' className='submit-btn' disabled={!this.validateForm()} type="submit">
                    Start
                </Button>
                </form>
              <div className={classes.error}>
                  <Typography variant='body2'>* If you fail to sign up, contact: eunyoungko@kaist.ac.kr </Typography></div>
            </div>
          );
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state.loading,
        error: state.error
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (username, password) => dispatch(actions.authSignup(username, password)) 
    }
}


export default compose(
    connect(
      mapStateToProps,
      mapDispatchToProps, // or put null here if you do not have actions to dispatch
    ),
    withStyles(useStyles),
  )(MTurkSignUp);